import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import Edit from "@material-ui/icons/Edit";
import Save from "@material-ui/icons/Save";
import * as moment from "moment";
import React from "react";
import { MediaLinesRequestFactory } from "../model/autogen/MediaLinesController";
import { TodaysLinesRequestFactory } from "../model/autogen/TodaysLinesController";
import { TodaysLinesModel } from "../model/autogen/TodaysLinesModel";
import { canEditTopLines } from "../model/content-access";
import { Content } from "./content";
import { RTEField } from "./forms/rte-field";
import { SanitisedHtml } from "./html";
import { IAuthContextProps, withAuthContext } from "./with-auth-context";
import { ISnackbarContextProps, withSnackbar } from "./with-snackbar";
import { NBSP } from "../utils/string";
import { TopLineUsageContext } from "model/autogen/TopLineUsageContext";
import { UserLevel } from "model/autogen/UserLevel";

interface IDailyMediaLineProps {
    /**
     * If true, will enable edit functionality iff the current user is permitted
     */
    enableEdit?: boolean;
    showBigTitle?: boolean;
    customBigTitle?: string;
    isExternal: boolean;
    context: TopLineUsageContext;
}

interface IMediaLineState {
    model?: TodaysLinesModel;
    editingCorePosition: string;
    isEditing: boolean;
    isSaving: boolean;
}

type DailyMediaLineProps = IDailyMediaLineProps & IAuthContextProps & ISnackbarContextProps;

class DailyMediaLine extends React.Component<DailyMediaLineProps, IMediaLineState> {
    constructor(props: DailyMediaLineProps) {
        super(props);
        this.state = {
            editingCorePosition: "",
            isEditing: false,
            isSaving: false
        };
    }
    public async componentDidMount() {
        const model = await this.props.callApi((fetcher) => TodaysLinesRequestFactory.get(fetcher, this.props.context, this.props.isExternal));
        this.setState({ model });
    }
    private onBeginEdit = () => {
        this.setState({ isEditing: true, editingCorePosition: this.state.model!.corePosition });
    }
    private onSaveChanges = async () => {
        const { callApi, showSnackbarMessage } = this.props;
        const { model } = this.state;
        if (model) {
            this.setState({ isSaving: true });
            const payload: any = {
                text: this.state.editingCorePosition,
                usageContext: this.props.context,
                isExternal: model.isExternal
            };
            const newTopLines = await callApi(f => MediaLinesRequestFactory.updateTopLine(f, payload));
            model!.corePosition = newTopLines.text;
            this.setState({ isSaving: false, isEditing: false, editingCorePosition: "", model: model });
            showSnackbarMessage(`Top lines updated`);
        }
    }
    private onEditingValueChanged = (e: any) => {
        this.setState({ editingCorePosition: e.target.value })
    }
    public render() {
        const { user, enableEdit, showBigTitle, isExternal } = this.props;
        const { isEditing, model, editingCorePosition, isSaving } = this.state;
        let visLabel: React.ReactNode = <></>;
        if (user.level >= UserLevel.Admin)
            visLabel = isExternal ? "External." : "Internal.";
        return <div>
            {model != null && (<div>
                {showBigTitle === true && <h1>{this.props.customBigTitle || "Current Media Lines"}</h1>}
                <small>{visLabel} {model.lastUpdated && <>Last updated at {moment(model.lastUpdated).format("LLL")}</>}</small>
                <Card>
                    {(() => {
                        if (isEditing) {
                            return <RTEField name="topline" value={editingCorePosition} onChange={this.onEditingValueChanged} />
                        } else {
                            return <Content>
                                <SanitisedHtml html={model.corePosition} />
                            </Content>;
                        }
                    })()}
                </Card>
                {isEditing == false && enableEdit === true && canEditTopLines(user) && <Button style={{marginTop: '20px', float: 'right'}} className="edit-top-lines-button" disabled={isSaving} variant="contained" color="primary" onClick={this.onBeginEdit}><Edit />{NBSP}Edit</Button>}
                {isEditing == true && <Button className="save-top-lines-button" style={{float:'right', marginTop: '20px'}} disabled={isSaving} variant="contained" color="primary" onClick={this.onSaveChanges}><Save />{NBSP}Save</Button>}
            </div>)}
        </div>
    }
}

export const MediaLines = withSnackbar(withAuthContext(DailyMediaLine)) as React.ComponentType<IDailyMediaLineProps>;


// WEBPACK FOOTER //
// ./src/components/daily-media-line.tsx